"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeSvgPath = exports.svgPathCache = void 0;
var ff_svgpath_1 = require("ff-svgpath");
var ComputeCache_1 = require("./caching/ComputeCache");
/**
 * Used to store SVG path parsing results. Apps may call {@code svgPathCache.gc()} to
 * run the garbage collector. This doesn't happen automatically. Most apps won't need
 * to use this feature: only if the app is creating/discarding many paths on the fly.
 */
exports.svgPathCache = new ComputeCache_1.ComputeCache();
/**
 * Executes an SVG-style path string on a canvas rendering context.
 *
 * @param path A path string, e.g. "M100,50L75,94.2H25L0,50L25,5.8h50L100,50z"
 * @param ctx The canvas rendering context.
 */
function executeSvgPath(path, ctx) {
    var e_1, _a;
    try {
        for (var _b = __values(exports.svgPathCache.access(path, function () { return ff_svgpath_1.parse(path); })), _c = _b.next(); !_c.done; _c = _b.next()) {
            var op = _c.value;
            ctx[op.type].apply(ctx, op.args);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.executeSvgPath = executeSvgPath;
//# sourceMappingURL=executeSvgPath.js.map